/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationSkippedDetails {
    getFixupPrototypeFunction() { return ResourceRecommendationSkippedDetails.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationSkippedDetails>): ResourceRecommendationSkippedDetails {
        let obj = Object.assign(new ResourceRecommendationSkippedDetails(), model);
        ResourceRecommendationSkippedDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationSkippedDetails>): ResourceRecommendationSkippedDetails {
        if (!model) return null;
        return ResourceRecommendationSkippedDetails.newInstance(<ResourceRecommendationSkippedDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationSkippedDetails) {
        if (!obj) return;

        models.ResourceRecommendationSkippedDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationSkippedDetails): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationSkippedDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action name for skipped resource
     */
    action: string;

    /**
     * ID from where the resource is being skipped.
     */
    id: string;

}
